var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    fill: "#fff"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    fill: "url(#A)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F",
    fill: "#fff"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F",
    fill: "url(#A)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    fill: "#fff"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    fill: "url(#A)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    fill: "#fff"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    fill: "url(#A)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    fill: "#fff"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    fill: "url(#A)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    fill: "url(#B)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    fill: "url(#C)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    fill: "url(#D)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 27.58,
    y1: 3.179,
    x2: 21.894,
    y2: 22.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e980fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 18.004,
    y1: 14.948,
    x2: 18.004,
    y2: 43.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 18.004,
    y1: 14.948,
    x2: 18.004,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 23.021,
    y1: 13.944,
    x2: 11.105,
    y2: 31.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e980fc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M18.664 4.668c0-.369-.297-.668-.663-.668s-.663.299-.663.668v4.005c0 .369.297.668.663.668s.663-.299.663-.668V4.668z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "M8.318 15.982a.67.67 0 0 0-.243-.912l-3.447-2.003a.66.66 0 0 0-.906.244.67.67 0 0 0 .243.912l3.447 2.002a.66.66 0 0 0 .906-.244z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M26.806 7.089a.67.67 0 0 0-.243-.912.66.66 0 0 0-.906.244l-1.99 3.468a.67.67 0 0 0 .243.912.66.66 0 0 0 .906-.244l1.99-3.468z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "M12.093 10.802a.67.67 0 0 0 .243-.912l-1.99-3.468a.66.66 0 0 0-.906-.244.67.67 0 0 0-.243.912l1.99 3.468a.66.66 0 0 0 .906.244z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M32.037 14.224a.67.67 0 0 0 .243-.912.66.66 0 0 0-.906-.244l-3.447 2.003a.67.67 0 0 0-.243.912.66.66 0 0 0 .906.244l3.447-2.002z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M24.162 23.842v5.474c0 .41-.274.684-.684.684H12.53c-.411 0-.684-.274-.684-.684v-5.474h5.474V30h1.368v-6.158h5.474zm-6.842-4.789h-6.158c-.41 0-.684.274-.684.684v2.053c0 .41.274.684.684.684h6.158v-3.421zm7.526 0h-6.158v3.421h6.158c.41 0 .684-.274.684-.684v-2.053c0-.41-.274-.684-.684-.684zm-1.984-.753l.068-.274c.274-.684.205-1.505-.205-2.121s-1.163-.958-1.916-.958c-.958 0-1.779.547-2.121 1.437l-1.368 3.353h3.421c.889 0 1.779-.547 2.121-1.437zm-2.874-1.437a.89.89 0 0 1 .821-.547c.274 0 .547.137.753.411.137.274.205.547.068.821l-.068.274a.89.89 0 0 1-.821.547h-1.368l.616-1.505zm-2.668-.479c-.342-.889-1.232-1.437-2.121-1.437-.753 0-1.505.342-1.916 1.026-.411.616-.479 1.368-.205 2.121l.068.274c.342.821 1.231 1.368 2.121 1.368h3.353l-1.3-3.353zm-1.3.479l.616 1.505h-1.368a.89.89 0 0 1-.821-.547l-.137-.274c-.068-.274-.068-.616.137-.821.137-.274.411-.411.753-.411a.89.89 0 0 1 .821.547z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodyIcon);
export default __webpack_public_path__ + "static/media/Goody_icon.66e433ecc06fdab824d2ca96920fd3c1.svg";
export { ForwardRef as ReactComponent };